import { atomWithStorage } from 'jotai/utils';
import { LOCAL_STORAGE } from '@/functions/constants/enums';

export const matchModalShownKey = LOCAL_STORAGE.MATCH_MODAL_SHOWN.KEY;

export const matchModalShownAtom = atomWithStorage<{ [id: number]: boolean }>(matchModalShownKey, {});
